import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export const getSearchResult = async (d) => {
  const payload = Object.fromEntries(
    Object.entries(d).filter(([_, value]) => value !== null && value !== undefined)
  );

  const response = await axios.post(
    `${API_URL}/flightstatus`,
    {...payload}
  );

  return response;
};
